export default __webpack_public_path__ + "f9e8e590b4e0f1ff83469bb2a55b8488.woff";